// Where Settings (SettingsModal) is: ?settings=menu or a section (lib/sectionNav.ts).
import { useSectionNav } from './sectionNav'

/** A section of Settings. */
export type SettingsSection = 'profile' | 'av' | 'devices' | 'storage' | 'migration'

export const useSettingsNav = () => useSectionNav<SettingsSection>('settings')
